import { LazyRenderLayer } from 'core/layouts/ui-blocks/ReusableComponents';
import { ComponentLoadingScreen } from 'core/navigation/loading-screen/LoadingScreen';
import { homePageUpscale8kModelSelector } from 'core/store/reducers/homeReducer/HomeSlice';
import React, { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';

const Upscale8kModal = lazy(() => import('./Upscale8kModal'));

function LazyUpscale8kModal() {
	const isModalOpen = useSelector(homePageUpscale8kModelSelector);

	return (
		<LazyRenderLayer isShown={isModalOpen}>
			<Suspense fallback={<ComponentLoadingScreen />}>
				<Upscale8kModal />
			</Suspense>
		</LazyRenderLayer>
	);
}

export default LazyUpscale8kModal;
